<div class="modal-header" style="position:relative;">
  @if (!submitted) {
    <span style="font-size: large">
      {{formTitle}}
    </span>
  }
  @if (submitted === 3) {
    <span style="font-size: large">
      Successfully Uploaded
    </span>
  }
  @if (submitted && submitted !== 3) {
    <span style="font-size: large">
      Thank you
    </span>
  }
  <button aria-label="Close The Modal" (click)="formCancelled.emit()" class="button-without-border close-icon" ><span aria-hidden="true">&times;</span></button>
</div>
<div class="modal-body" [ngClass]="{ loading: gettingClients || submittingTheForm }">
  @if (submitted) {
    <div>
      @if (submitted === 1 || submitted === 2) {
        <p>
          Thank you for your enquiry / request. A member of the Advisory Team will get back to you within the next few business days.
        </p>
      }
      @if (submitted === 3) {
        <p>
          Your document has been successfully uploaded and can be found in the <b>Your Uploads</b> tab of the <b>Documents page</b>.
        </p>
      }
      @if (submitted === 4) {
        <p>
          Thank you for your request. A member of the Advisory Team or PGF Team will get back to you within the next few business days.
        </p>
      }
    </div>
  }
  @if (!submitted) {
    <div class="row mb-5">
      @if (formAction === 'PgfDonation') {
        <div class="col-md-12">
          <label class="pt-3 mb-1 form-title" for="amount_0">How much would you like to donate to {{selectedReRg?.ClientName}}?</label>
          <div class="formatted-input">
            <input name="amount_0" id="amount_0" type="number" [(ngModel)]="pgfRequests[0].amount" class="form-control">
            <span>{{pgfRequests[0].amount | currency:'USD': 'symbol':'1.0-2'}}</span>
          </div>
          <label class="pt-3 mb-1 form-title" for="message">
            Are there any other comments you would like to make?
          </label>
          <span class="small-label">Please provide us with as much information as you can. A member of your Advisory Team will contact you about your request.</span>
          <textarea class="form-control form-field w-100" rows="4" id="message"
          [(ngModel)]='pgfRequests[0].message'></textarea>
        </div>
      }
      @if (formAction === 'PgfGrant') {
        @for (r of pgfRequests; track r; let i = $index) {
          <div class="col-md-12 pb-4 pgfGrant">
            <label class="pt-3 mb-0 form-title" for="charity_{{i}}">Which charity would you like to send a grant to?</label>
            <input name="charity_{{i}}" id="charity_{{i}}" type="text" [(ngModel)]="r.charity" class="form-control">
            <label class="pt-3 mb-0 form-title" for="amount_{{i}}">How much would you like to grant?</label>
            <span class="small-label">Minimum grant of $500.</span>
            <div class="formatted-input">
              <input name="amount_{{i}}" id="amount_{{i}}" type="number" [(ngModel)]="r.amount" class="form-control" min="500" max="999999999">
              <span>{{r.amount | currency:'USD': 'symbol':'1.0-2'}}</span>
            </div>
            <label class="pt-3 mb-1 form-title" for="message_{{i}}">
              Are there any other comments you would like to make?
            </label>
            <span class="small-label">Such as designation or charity contact.</span>
            <textarea class="form-control form-field w-100" rows="4" id="message_{{i}}"
            [(ngModel)]='r.message'></textarea>
          </div>
        }
        <div class="col-md-12">
          <button class="btn btn-outline-primary" (click)="addPgfRequests()">Add Another Grant +</button>
        </div>
      }
      @if (formAction === 'MessageAdvisor' || formAction === 'SendDocuments') {
        <div class="col-md-12">
          <div class="form-title mb-1">How would you like us to contact you back?</div>
          <div class="custom-control custom-radio py-1">
            <input type="radio" class="custom-control-input" id="r2" name="options" value="email"
              [(ngModel)]="contact.option">
            <label class="custom-control-label" for="r2">Email: {{client.email}}</label>
          </div>
          @if (hasPreferredPhone) {
            <div class="custom-control custom-radio py-1">
              <input type="radio" class="custom-control-input" id="r1" name="options" value="phone"
                [(ngModel)]="contact.option">
              <label class="custom-control-label" for="r1">Phone:  {{client.phone}}</label>
            </div>
          }
          <div class="custom-control custom-radio d-inline-block mr-2">
            <input type="radio" class="custom-control-input" id="r3" name="options" value="other"
              [(ngModel)]="contact.option">
            <label class="custom-control-label" for="r3">Other Method</label>
          </div>
          <input name="other" type="text" [(ngModel)]="contact.text" [disabled]="contact.option !== 'other'"
            class="form-control" style="width:300px;display:inline;" placeholder="How should we contact you?">
          @if (gettingClients) {
            <div style="height:38px" class="mb-3"></div>
          }
          @if (!gettingClients) {
            @if (formAction === 'SendDocuments' && clientsList.length === 0) {
              <div class="mb-3">
                <div class="pt-2 form-title">
                  <label for="selectedDocumentAction">These documents related to my</label>
                </div>
                <div>
                  <select [(ngModel)]="selectedDocumentAction" [class.field-error]="hasDocRelateError"
                    name="selectedDocumentAction" class="form-control form-field w-100" id="selectedDocumentAction"
                    required (change)="resetFormError()" [attr.aria-invalid]="hasDocRelateError">
                    @for (c of document_actions; track c) {
                      <option [value]="c.id">{{c.value}}</option>
                    }
                  </select>
                </div>
                @if (hasDocRelateError) {
                  <div class="error">Please select an option from the dropdown</div>
                }
              </div>
            }
            @if (formAction === 'SendDocuments' && clientsList.length>0) {
              <div class="mb-3">
                <div class="pt-2 form-title">
                  <label for="selectedClient">Client:</label>
                </div>
                <div>
                  <select [(ngModel)]="selectedClient" name="selectedClient" class="form-control form-field w-100"
                    id="selectedClient" required [attr.aria-invalid]="hasSelectClientError">
                    @for (c of clientsList; track c) {
                      <option [value]="c.NameId">{{c.DisplayName}}</option>
                    }
                  </select>
                </div>
                @if (hasSelectClientError) {
                  <div class="error">Please select an client from the dropdown</div>
                }
              </div>
            }
          }
          <div class="pt-2 form-title">
            <label for="user-request-message">Message</label>
          </div>
          <div>
            <textarea id="user-request-message" class="form-control form-field w-100" rows="4" [class.field-error]="hasMessageError"
              [(ngModel)]='contactMsg' (keyup)="this.contactMsg.length > 0 ?resetFormError():''"
            placeholder="Please type your message for our team here..."></textarea>
            @if (hasMessageError) {
              <div class="error">Please add a message</div>
            }
          </div>
          @if (!isImpersonated && !config.demoSite && !isMFARequest) {
            <div class="form-control form-field upload-container mt-2"
              [class.field-error]="hasFileUploadError"
              [ngClass]="{ 'drag-over': isDragOver }" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
              <input #attachFiles type="file" multiple id="selectedFile" #fileUpload (change)="fileChange($event)" [attr.aria-invalid]="hasFileUploadError" class="d-none"/>
              <div class="mt-5">
                <b>Drag and Drop Files or</b>
                <button class="btn btn-link link-primary" style="padding-left: 3px;margin-top: -2px;text-decoration: underline;height: unset;" onclick="document.getElementById('selectedFile').click();"><b>Click to Browse</b></button>
              </div>
              <span style="color: #5C5C5C;font-size: smaller;">@if (formAction === 'SendDocuments') {
                <span>ZIP, </span>
              }PDF, JPEG, PNG, GIF, Word, PWPT</span>
            </div>
          }
          @if (hasFileUploadError) {
            <div class="error">Please upload at least one document</div>
          }
        </div>
      }
    </div>
    @for (formFile of formFiles; track formFile; let i = $index) {
      <div>
        <div class="">
          <div class="upload-file-name">
            <button class="close" (click)="removeAttachment(i)" style="line-height:.8em;" ngbTooltip="Remove the Attachment" aria-label="Remove the Attachment">&times;</button>
            <strong>{{formFile.file.name}}</strong>
          </div>
          @if (formFile.hasRestrictedFileType) {
            <div>
              <div class="error mt-3">
                We apologize for the inconvenience, but one or more of the documents you are attempting to upload is not
                an accepted file type.
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (hasCombinedMaxFileUploadError) {
      <div>
        <div>
          <div class="error mt-3">
            Maximum combined file upload size is 25MB, please reduce file size and try again. Or please consider <span
          class="tooltip-msg" container="body" [ngbTooltip]="sendMailMsg">mail option.</span>
        </div>
      </div>
    </div>
  }
  @if (hasDuplicatedFilesError) {
    <div>
      <div>
        <div class="error mt-3">
          Sorry, file with the same name has already been attached.
        </div>
      </div>
    </div>
  }
  <ng-template #sendMailMsg><p>If you wish to send us documents by mail, we can send you a post-marked document
  envelope in the mail. Also, couriers can also be arranged for sensitive documents and/or large packages. </p>
  <p>For either of these services, please contact our office reception at <b>604-739-6450</b>.</p></ng-template>
}
</div>
@if (!alreadySubmitted) {
  <div class="modal-footer" style="justify-content: flex-start">
    @if (submitted && submitted!==4) {
      @if (submitted!==3) {
        <button type="button" class="btn btn-sm btn-secondary" (click)="reset()" tabindex="-1">Submit New Request</button>
      }
      @if (submitted===3) {
        <button type="button" class="btn btn-sm btn-secondary" (click)="reset()" tabindex="-1">Upload Another Document</button>
      }
    }
    @if (!submitted) {
      @if (formAction === 'PgfDonation' || formAction === 'PgfGrant') {
        <div class="pgfButton">
          <button type="button" class="btn btn-sm btn-primary" (click)="submitPgf()"
            [disabled]="isImpersonated"
            [title]="isImpersonated ? 'This functionality is not available in the impersonation mode' :''">
            @if (formAction === 'PgfDonation') {
              <span>Send Donation Request</span>
            }
            @if (formAction === 'PgfGrant') {
              <span>Send Grant Request</span>
            }
          </button>
        </div>
      }
      @if (!(formAction === 'PgfDonation' || formAction === 'PgfGrant')) {
        <div>
          <button type="button" class="btn btn-sm btn-primary" (click)="submit()"
            [disabled]="hasMaxFileUploadError || hasRestrictedFileType || hasCombinedMaxFileUploadError || isImpersonated || config.demoSite"
            [title]="config.demoSite ? 'This functionality is not available on Demo Web Site' :''">
            @if (formAction !== 'SendDocuments') {
              <span>Send Message</span>
            }
            @if (formAction === 'SendDocuments') {
              <span>Upload Documents</span>
            }
          </button>
        </div>
      }
      @if (formError && formAction !== 'SendDocuments') {
        <div class="error">
          Please ensure the relevant fields are filled.
        </div>
      }
      @if (formError && formAction === 'SendDocuments') {
        <div class="error">
          Please ensure the relevant fields are filled and a document has been added.
        </div>
      }
      @if (hasSubmitError) {
        <div class="error">
          We are unable to submit your request. Please try again later.
        </div>
      }
    }
  </div>
}
